module.exports = __webpack_public_path__ + "static/media/yellowTheme-girl.25752432.svg";